export default function Continuar() {
  return (
    <section className="continuar">
      <div>
        <h1>Continuar</h1>
      </div>
    </section>
  );
}
